module.exports = __webpack_public_path__ + "img/UTFREM-7.9d84d76c.jpg";